import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreBold = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16 17.5C16.8284 17.5 17.5 16.8284 17.5 16C17.5 15.1715 16.8284 14.5 16 14.5C15.1716 14.5 14.5 15.1715 14.5 16C14.5 16.8284 15.1716 17.5 16 17.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 17.5C9.32843 17.5 10 16.8284 10 16C10 15.1715 9.32843 14.5 8.5 14.5C7.67157 14.5 7 15.1715 7 16C7 16.8284 7.67157 17.5 8.5 17.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5 17.5C24.3284 17.5 25 16.8284 25 16C25 15.1715 24.3284 14.5 23.5 14.5C22.6716 14.5 22 15.1715 22 16C22 16.8284 22.6716 17.5 23.5 17.5Z",
			fill: "currentColor"
		})
	]
});
export default SvgMoreBold;
